var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1371 11.9991C20.6361 11.9991 21.0456 11.5931 20.9959 11.0968C20.7875 9.02111 19.8677 7.08137 18.3926 5.60642C16.9175 4.13147 14.9777 3.21208 12.9022 3.0041C12.405 2.95437 12 3.36393 12 3.863V11.0959C12 11.3357 12.0952 11.5656 12.2648 11.7352C12.4343 11.9047 12.6643 12 12.904 12L20.1371 11.9991Z",
    stroke: "#37424F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5845C19.437 16.919 18.5565 18.0949 17.4353 19.0095C16.3142 19.9241 14.9866 20.5495 13.5687 20.831C12.1507 21.1125 10.6855 21.0415 9.30124 20.6243C7.91695 20.2071 6.6557 19.4564 5.62775 18.4377C4.5998 17.419 3.83646 16.1635 3.40445 14.7808C2.97244 13.3981 2.88493 11.9304 3.14956 10.506C3.41418 9.08153 4.0229 7.74377 4.92248 6.60963C5.82206 5.47549 6.98512 4.5795 8.30998 4",
    stroke: "#37424F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.df11faedb0b4e2d321abcc7f89da3d4a.svg";
export { ForwardRef as ReactComponent };